'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { useIsBuy1Get1ValueMatchCampaignActive } from '@/lib/utils/campaign/campaign-active'
import Image from 'next/image'
import { usePathname } from 'next/navigation'

export const BlackFridayBanner = () => {
  const isCampaignActive = useIsBuy1Get1ValueMatchCampaignActive()
  const pathname = usePathname()

  // Ẩn banner khi đang ở trang /black-friday (bất kể có query params hay không)
  // path có thể là '/en/black-friday', '/black-friday', v.v.
  // Ta chỉ kiểm tra phần cuối cùng của pathname
  const blackFridayPath =
    pathname === '/black-friday' || pathname.endsWith('/black-friday')

  if (!isCampaignActive || blackFridayPath) {
    return null
  }

  return (
    // <CollectionContainer className='py-3 sm:py-4 lg:mt-6 lg:py-5'>
    <a
      aria-label='Black Friday Banner'
      href='/blog/coolmate-chinh-thuc-kich-hoat-chuong-trinh-black-friday-2025'
      target='_blank'
      rel='noopener noreferrer'
      className='block w-full transition-opacity hover:opacity-95 active:opacity-90'
    >
      {/* Mobile Image */}
      <div className='relative w-full lg:hidden'>
        <Image
          src={ImageHelper.getImageUrl('/image/November2025/mceclip0_49.png')}
          alt='Black Friday Banner'
          className='object-contain object-center'
          width={768}
          height={393}
          priority
          loading='eager'
          fetchPriority='high'
        />
      </div>

      {/* Desktop Image */}
      <div className='relative hidden w-full lg:block'>
        <Image
          src={ImageHelper.getImageUrl('/image/November2025/mceclip2_22.png')}
          alt='Black Friday Banner'
          width={1920}
          height={400}
          className='object-contain object-center'
          priority
          loading='eager'
          fetchPriority='high'
        />
      </div>
    </a>
    // </CollectionContainer>
  )
}
